import type { UiAccordion } from '@afs/design-system'

export function openLegalNotice(
  legalNoticeAccordion: InstanceType<typeof UiAccordion> | null,
): HTMLDetailsElement | undefined {
  if (!legalNoticeAccordion) return

  const legalNoticeItem = legalNoticeAccordion.accordionItemsRefs[0] as HTMLDetailsElement

  legalNoticeItem.setAttribute('open', '')
  return legalNoticeItem
}

export function scrollToLegalNotice(legalNoticeAccordion: InstanceType<typeof UiAccordion> | null): void {
  const legalNoticeItem = openLegalNotice(legalNoticeAccordion)
  legalNoticeItem?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}
